import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import blockedAutoplayMessage, { allowAutoplayHint } from '../../utils/blocked-autoplay-message';

export default class SystemAutoplayBlocked extends Component {
  @service playback;

  get sound() {
    return this.playback.blockedSound;
  }

  get message() {
    let airing = this.sound?.metadata?.airing;
    return blockedAutoplayMessage({ title: airing?.showTitle ?? airing?.show?.title });
  }

  get hint() {
    return allowAutoplayHint();
  }

  @action
  play() {
    this.sound?.play();
  }
}
